import { render, staticRenderFns } from "./OrganizationsTree.vue?vue&type=template&id=9b54d60e&"
import script from "./OrganizationsTree.vue?vue&type=script&lang=ts&"
export * from "./OrganizationsTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports